import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomBaseQuery } from "./customBaseQuery";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL!.replace(/\/$/, "");

export const chatApi = createApi({
  reducerPath: "chatApi",
  baseQuery: createCustomBaseQuery(
    `${API_BASE_URL}/design/`
  ),
  endpoints: (builder) => ({
    generateDesign: builder.mutation<any, { user: string; userInstruction: string; projectType: string; file?: File }>({
      query: ({ user, userInstruction,projectType, file }) => {
        const formData = new FormData();
        formData.append("user_id", user);
        formData.append("user_instruction", userInstruction);
        formData.append("project_type", projectType);
        if (file) formData.append("file", file);

        return {
          url: "generate-design",
          method: "POST",
          body: formData,
        };
      },
    }),

    generateImages: builder.mutation<any, string>({
      query: (appProjectId) => ({
        url: "generate-images",
        method: "POST",
        body: { app_project_id: appProjectId },
      }),
    }),

    fetchImages: builder.mutation<any, string>({
      query: (appProjectId) => ({
        url: "fetch-images",
        method: "POST",
        body: { app_project_id: appProjectId },
      }),
    }),

    fetchProjects: builder.mutation<any, { user_id: string }>({
      query: ({ user_id }) => ({
        url: "projects",
        method: "POST",
        body: { user_id },
      }),
    }),

    getDisplayApps: builder.query<any, void>({
      query: () => ({
        url: "display-apps",
        method: "GET",
      }),
    }),

    getTermsAndConditions: builder.query<any, void>({
      query: () => ({
        url: "terms-and-conditions",
        method: "GET",
      }),
    }),

    getPrivacyPolicy: builder.query<any, void>({
      query: () => ({
        url: "privacy-policy",
        method: "GET",
      }),
    }),

    fetchProjectInfo: builder.mutation<any, { project_id: string }>({
      query: ({ project_id }) => ({
        url: "project-info",
        method: "POST",
        body: { project_id },
      }),
    }),

    // ✅ Existing user info mutation
    storeUser: builder.mutation<any, {uid: string;email: string;emailVerified: boolean;displayName: string;isAnonymous: boolean;photoURL: string;providerId: string;}>({
      query: (userData) => ({
        url: "user",
        method: "POST",
        body: userData,
      }),
    }),

    getLoadingProgressImages: builder.query<any, { app_project_id: string }>({
      query: ({ app_project_id }) => ({
        url: "loading-progress-images",
        method: "GET",
        params: { app_project_id },
      }),
    }),

    fetchAppStatus: builder.mutation<any, { app_project_id: string }>({
      query: ({ app_project_id }) => ({
        url: "app-status",
        method: "POST",
        body: { app_project_id },
      }),
    }),

    // 🔹 Get Billing Payment Pricing markdown content
    getBillingPaymentPricing: builder.query<any, void>({
      query: () => ({
        url: "billing-payment-pricing",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGenerateDesignMutation,
  useGenerateImagesMutation,
  useFetchImagesMutation,
  useFetchProjectsMutation,
  useGetDisplayAppsQuery,
  useGetTermsAndConditionsQuery,
  useGetPrivacyPolicyQuery,
  useLazyGetTermsAndConditionsQuery,
  useLazyGetPrivacyPolicyQuery,
  useFetchProjectInfoMutation,
  useStoreUserMutation,
  useGetLoadingProgressImagesQuery,
  useFetchAppStatusMutation,
  useGetBillingPaymentPricingQuery,
} = chatApi;
